import api from "../api";

// Tribe Tasks
export const createTribeTask = async (tribeId, data) => {
  const response = await api.getApi().post(`/tribes/${tribeId}/tasks`, data);
  return response.data;
};

export const getTribeTasks = async (tribeId) => {
  const response = await api.getApi().get(`/tribes/${tribeId}/tasks`);
  return response.data;
};

export const joinTribeTask = async (tribeId, taskId) => {
  const response = await api.getApi().post(`/tribes/${tribeId}/tasks/${taskId}/join`);
  return response.data;
};

export const leaveTribeTask = async (tribeId, taskId) => {
  const response = await api.getApi().delete(`/tribes/${tribeId}/tasks/${taskId}/leave`);
  return response.data;
};

export const getTaskParticipants = async (tribeId, taskId) => {
  const response = await api.getApi().get(`/tribes/${tribeId}/tasks/${taskId}/participants`);
  return response.data;
};

// Tribe Habits
export const createTribeHabit = async (tribeId, data) => {
  const response = await api.getApi().post(`/tribes/${tribeId}/habits`, data);
  return response.data;
};

export const getTribeHabits = async (tribeId) => {
  const response = await api.getApi().get(`/tribes/${tribeId}/habits`);
  return response.data;
};

export const joinTribeHabit = async (tribeId, habitId) => {
  const response = await api.getApi().post(`/tribes/${tribeId}/habits/${habitId}/join`);
  return response.data;
};

export const leaveTribeHabit = async (tribeId, habitId) => {
  const response = await api.getApi().delete(`/tribes/${tribeId}/habits/${habitId}/leave`);
  return response.data;
};

export const getHabitParticipants = async (tribeId, habitId) => {
  const response = await api.getApi().get(`/tribes/${tribeId}/habits/${habitId}/participants`);
  return response.data;
};
